/* eslint-disable camelcase */
import { OrderStage as ReportOrderStage } from './reportOrder';

export enum OrderStage {
  UNDERCHECK=1, // 审核中
  UNDERWAY, // 进行中
  UNCONFIRMED, // 待验收
  UNCOMMENT, // 待评价
  COMPLETED // 已完成
}

export declare class IOrderParams {
  user_id: number
  company_id: string
  page: number
  size?: number
  stage: OrderStage | ReportOrderStage
}

export declare class IOrderOperationParams {
  user_id: number
  user_name?: string
  company_id: string
  order_id: number
  remark?: string
}

export declare class IOrderListItem {
  id: number
  orderNum: string
  orderType: number
  troubleDescribe: string
  troubleImageList: any[]
  servicerCompanyName: string
  name: string
  mobile: string
  address: string
  lastStateDetail: string
  charge: number
  expedited: number
  isRanking: number
  ranking: number
  [key: string]: any
}

export declare class IOrderColspan {
  row?: number
  column?: number
  rowIndex?: number
  columnIndex?: number
}
